import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'
import { useAuth } from 'shared/utils/auth'

const PrivateRoute = ({ component: Component, path, location, ...rest }) => {
  const { isAuthenticated, loading, authError, login } = useAuth()

  useEffect(() => {
    // Wait for the provider to settle before starting a login: login() is a
    // full-page redirect to the hosted UI, and firing it while the ?code=
    // exchange is still in flight would navigate away and throw the
    // (single-use) code away.
    if (loading) return

    // Never auto-redirect while a login rejection is on screen — retrying
    // immediately would bounce the user straight back to the hosted UI and the
    // message would never be readable.
    if (authError) return

    if (!isAuthenticated) {
      login()
    }
  }, [ isAuthenticated, loading, authError, login, path, location ])

  const render = props =>
    isAuthenticated === true && <Component {...props} />

  return <Route path={path} render={render} {...rest} />
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([ PropTypes.element, PropTypes.func ])
    .isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
}

export default withRouter(PrivateRoute)
